import {getRequest} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {ICreation} from "../types/ICreation";
import {AdCreationError} from "./creation_error_class";

export async function fetchNativeAd(creationId: number) {
    try {
        const url = apiV2Link.adverts.natives.detail({nativeId: creationId});
        const creationDetails = await getRequest(clientRpRequestMeta, url);

        return creationDetails as ICreation;
    } catch (error) {
        notifyBugsnag(error, "fetchNativeAd: catch", {originalError: JSON.stringify(error)});

        throw new AdCreationError(`creation ${creationId} not found`);
    }
}
import {getRequest} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {ICreation} from "../types/ICreation";
import {AdCreationError} from "./creation_error_class";

export async function fetchNativeAd(creationId: number) {
    try {
        const url = apiV2Link.adverts.natives.detail({nativeId: creationId});
        const creationDetails = await getRequest(clientRpRequestMeta, url);

        return creationDetails as ICreation;
    } catch (error) {
        notifyBugsnag(error, "fetchNativeAd: catch", {originalError: JSON.stringify(error)});

        throw new AdCreationError(`creation ${creationId} not found`);
    }
}
